import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Grid, Header } from 'semantic-ui-react';
import { Field } from 'react-final-form';
import DatePicker from 'components/final-form/DatePicker';
import { required } from 'utils/validatorUtils';
import PraxFormGrid from 'components/layout/PraxFormGrid';

interface Props extends MessageSourceProps {}

class DetailsSegment extends Component<Props> {

  render(): React.ReactNode {

    const { getMessage } = this.props;

    return (
        <PraxFormGrid>
          <Grid.Row>
            <Grid.Column>
              <Header>{ getMessage("details") }</Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2} verticalAlign="middle">
              { getMessage("date") }:
            </Grid.Column>
            <Grid.Column width={4} verticalAlign={"middle"}>
              <Field
                  name="estimationDate"
                  component={DatePicker}
                  validate={required}
                  fluid
              />
            </Grid.Column>
            <Grid.Column width={3} verticalAlign="middle">
              { getMessage("costEstimation.expiryDate") }:
            </Grid.Column>
            <Grid.Column width={4} verticalAlign={"middle"}>
              <Field
                  name="expiryDate"
                  component={DatePicker}
                  fluid
              />
            </Grid.Column>
          </Grid.Row>
        </PraxFormGrid>
    );
  }
}

export default withMessages(DetailsSegment);
